const avatarHtml = (photo) => {
  const styles = 'display:block;border-radius:50%;'
  return photo ? `<img src="${photo}" alt="user photo" width="88" style="${styles}"/>` : ''
}

const setBlock = ({tag, styles}, text) => {
  return text ? `<${tag} style="${styles}">${text}</${tag}>` : ''
}

const setLink = (styles, href, text) => {
  return href ? ` <a href=${href} target="_blank" style="${styles}">${text}</a>` : ''
}

const setImg = (src, alt) => {
  const height = 12
  const styles = 'display:inline-block; vertical-align:middle;'
  return src ? ` <img alt="${alt || ''}" height="${height}" style="${styles}" src="${src}"/>` : ''
}

export {setBlock, setLink, setImg, avatarHtml}



// WEBPACK FOOTER //
// ./src/constants/signatureGmail/templates.js